// RFC-144: Shared constants for Vault Documents UI

export const VAULT_CATEGORY_LABELS: Record<string, string> = {
  POLICY: 'Policy',
  PROCEDURE: 'Procedure',
  TEMPLATE: 'Template',
  RECORD: 'Record',
  TRAINING: 'Training',
  REFERENCE: 'Reference',
  // Issue #476: auditor-delivered final report / certificate uploaded via the
  // cycle-complete dialog.
  CERTIFICATE: 'Certificate',
  OTHER: 'Other',
}

export const VAULT_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
}

export const VAULT_SOURCE_LABELS: Record<string, string> = {
  AGENT_GENERATED: 'Agent Generated',
  MANUAL: 'Manual',
  UPLOADED: 'Uploaded',
}
